import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcPencilColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 3,
			width: 3,
			height: 3,
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.3999,
			y: 4.09998,
			width: 2.7,
			height: .8,
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.6499,
			y: 4.09998,
			width: 2.7,
			height: .8,
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16.8999,
			y: 4.09998,
			width: 2.7,
			height: .8,
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.3999,
			y: 23.1,
			width: 2.7,
			height: .8,
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.6499,
			y: 23.1,
			width: 2.7,
			height: .8,
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16.8999,
			y: 23.1,
			width: 2.7,
			height: .8,
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23.1,
			y: 19.6004,
			width: 2.7,
			height: .8,
			transform: "rotate(-90 23.1 19.6004)",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23.1,
			y: 15.3504,
			width: 2.7,
			height: .8,
			transform: "rotate(-90 23.1 15.3504)",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23.1,
			y: 11.1004,
			width: 2.7,
			height: .8,
			transform: "rotate(-90 23.1 11.1004)",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4.09998,
			y: 19.6004,
			width: 2.7,
			height: .8,
			transform: "rotate(-90 4.09998 19.6004)",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4.09998,
			y: 15.3504,
			width: 2.7,
			height: .8,
			transform: "rotate(-90 4.09998 15.3504)",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4.09998,
			y: 11.1004,
			width: 2.7,
			height: .8,
			transform: "rotate(-90 4.09998 11.1004)",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 22,
			width: 3,
			height: 3,
			fill: "#8C81F7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22,
			y: 3,
			width: 3,
			height: 3,
			fill: "#8C81F7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22,
			y: 22,
			width: 3,
			height: 3,
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.5901 12.2816C13.2902 11.9817 12.8355 11.9309 12.4832 12.1292L7.4197 7.06604L16.6044 8.90298V9.23091C16.6044 9.78028 16.6878 10.7046 16.9398 11.6566C17.1935 12.615 17.6055 13.5533 18.2308 14.1785L18.5136 14.4614L14.4609 18.514L14.1781 18.2312C13.9067 17.9598 13.4738 17.7117 12.9411 17.4947C12.415 17.2804 11.8234 17.1089 11.2627 16.9754C10.7033 16.8422 10.1826 16.7487 9.80145 16.6885C9.6111 16.6585 9.45616 16.6368 9.3493 16.6227C9.29589 16.6157 9.25453 16.6105 9.22682 16.6072L9.19571 16.6035L9.18821 16.6026L9.18654 16.6025L8.89558 16.5701L7.06531 7.41875L12.1297 12.4828C11.9318 12.8351 11.9827 13.2895 12.2825 13.5893C12.6436 13.9503 13.229 13.9503 13.5901 13.5893C13.9512 13.2282 13.9512 12.6427 13.5901 12.2816Z",
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13.1543,
			y: 18.3847,
			width: 7.39701,
			height: 3.6985,
			transform: "rotate(-45 13.1543 18.3847)",
			fill: "#8C81F7"
		})
	]
});
export default SvgIcPencilColor;
